import React, { useEffect } from 'react'

import { Route } from 'react-router-dom'
//Local modules
import { bindActionCreators } from 'redux'
import { closeLoginModal } from 'redux/slices/loginModal'
import { connect } from 'react-redux'
import { useAuth0 } from 'libs/web-client/utils/auth0/src'

const UnguardedRoute = ({ closeLoginModal, ...rest }) => {
    // previously, this component would re-render on user state changes in redux
    // now, we'll do this by using the auth hook
    useAuth0()

    useEffect(() => {
        closeLoginModal()
    })

    return <Route {...rest} />
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            closeLoginModal,
        },
        dispatch,
    )

export default connect(null, mapDispatchToProps)(UnguardedRoute)
